import { DisplayMode, IS_IN_BTC_BUSINESS_TYPE_WAITLIST_LOCAL_STORAGE_KEY, IS_IN_BTC_RISK_WAITLIST_LOCAL_STORAGE_KEY, FetchState, RiskEligibility } from './index';
import { AccountType, InvestmentAccountMetadata } from '@square/dashboard-protos/models/squareup/invest/model';
import { CreateInvestmentAccountRequest, CreateBtcWithholdingConfigRequest, GetCurrentBitcoinPriceRequest, GetMaxWithholdingRequest, ListInvestmentAccountsRequest, ListRecentActivityRequest, UpdateBtcWithholdingConfigRequest, RetrieveInvestEligibilityRequest } from '@square/dashboard-protos/models/squareup/invest/service';
import { concat, from } from 'rxjs';
import { balance } from '@banking/ui/workflows/investments';
import { MIN_BITCOIN_DISPLAY_AMOUNT } from '@banking/ui/utils/constants';
import { INVEST_CREATE_UPDATE_WITHHOLDING, INVEST_COMPLETE_ONBOARDING, INVEST_CHECK_TWO_FACTOR, INVEST_LINK_CASH, INVEST_SET_WAITLISTED, INVEST_SET_CASH_LINKING_GRANT, INVEST_ELIGIBILITY, INVEST_ADD_TO_INELIGIBLE_WAITLIST } from '@banking/ui/utils/invest-cdp-events';
import { set as setToLocalStorage, remove as removeFromLocalStorage } from '@square/dashboard-utilities/utils/persistable';
import { OneTrustConsent } from '@square/dashboard-utilities/utils/one-trust/one-trust-compliance';
import { isInvestmentsRoute } from '@banking/ui/utils/investments';
export let ActionType = /*#__PURE__*/function (ActionType) {
  ActionType["AddToRiskWaitlist"] = "ADD_TO_RISK_WAITLIST";
  ActionType["CreateInvestmentAccountRequest"] = "CREATE_INVESTMENT_ACCOUNT_REQUEST";
  ActionType["CreateInvestmentAccountResponse"] = "CREATE_INVESTMENT_ACCOUNT_RESPONSE";
  ActionType["CreateBtcWithholdingConfigRequest"] = "CREATE_BTC_WITHHOLDING_CONFIG_REQUEST";
  ActionType["CreateBtcWithholdingConfigResponse"] = "CREATE_BTC_WITHHOLDING_CONFIG_RESPONSE";
  ActionType["GetCurrentBitcoinPriceRequest"] = "GET_CURRENT_BITCOIN_PRICE_REQUEST";
  ActionType["GetCurrentBitcoinPriceResponse"] = "GET_CURRENT_BITCOIN_PRICE_RESPONSE";
  ActionType["GetMaxWithholdingRequest"] = "GET_MAX_WITHHOLDING_REQUEST";
  ActionType["GetMaxWithholdingResponse"] = "GET_MAX_WITHHOLDING_RESPONSE";
  ActionType["ListInvestmentAccountsRequest"] = "LIST_INVESTMENT_ACCOUNTS_REQUEST";
  ActionType["ListInvestmentAccountsResponse"] = "LIST_INVESTMENT_ACCOUNTS_RESPONSE";
  ActionType["ListRecentActivityRequest"] = "LIST_RECENT_ACTIVITY_REQUEST";
  ActionType["ListRecentActivityResponse"] = "LIST_RECENT_ACTIVITY_RESPONSE";
  ActionType["NavigateToBankingHome"] = "NAVIGATE_TO_BANKING_HOME";
  ActionType["RetrieveInvestEligibilityRequest"] = "RETRIEVE_INVEST_ELIGIBILITY_REQUEST";
  ActionType["RetrieveInvestEligibilityResponse"] = "RETRIEVE_INVEST_ELIGIBILITY_RESPONSE";
  ActionType["RotateDisplayMode"] = "ROTATE_DISPLAY_MODE";
  ActionType["SetGrant"] = "SET_GRANT";
  ActionType["SetOnboardingScreen"] = "SET_ONBOARDING_SCREEN";
  ActionType["SetTwoFactorAuthEnabled"] = "SET_TWO_FACTOR_AUTH_ENABLED";
  ActionType["SetWaitlisted"] = "SET_WAITLISTED";
  ActionType["UpdateBtcWithholdingConfigRequest"] = "UPDATE_BTC_WITHHOLDING_CONFIG_REQUEST";
  ActionType["UpdateBtcWithholdingConfigResponse"] = "UPDATE_BTC_WITHHOLDING_CONFIG_RESPONSE";
  ActionType["ToggleModalOpen"] = "TOGGLE_MODAL_OPEN";
  ActionType["UserChangePhoneNumber"] = "TWO_FACTOR/USER_CHANGE_PHONE_NUMBER";
  ActionType["UserChangeVerificationCode"] = "TWO_FACTOR/USER_CHANGE_VERIFICATION_CODE";
  ActionType["UserClickEnroll"] = "TWO_FACTOR/USER_CLICK_ENROLL";
  ActionType["UserClickVerify"] = "TWO_FACTOR/USER_CLICK_VERIFY";
  ActionType["UserClickResendCode"] = "TWO_FACTOR/USER_CLICK_RESEND_CODE";
  ActionType["PhoneNumberEnrollTwoFactorReceived"] = "TWO_FACTOR/PHONE_NUMBER_ENROLL_TWO_FACTOR_RECEIVED";
  ActionType["PhoneNumberEnrollTwoFactorError"] = "TWO_FACTOR/PHONE_NUMBER_ENROLL_TWO_FACTOR_ERROR";
  ActionType["VerifyCodeEnrollTwoFactorReceived"] = "TWO_FACTOR/VERIFY_CODE_ENROLL_TWO_FACTOR_RECEIVED";
  ActionType["VerifyCodeEnrollTwoFactorError"] = "TWO_FACTOR/VERIFY_CODE_ENROLL_TWO_FACTOR_ERROR";
  ActionType["ToggleButtonLoading"] = "TWO_FACTOR/TOGGLE_BUTTON_LOADING";
  return ActionType;
}({});
export const addToRiskWaitlistAction = () => ({
  type: ActionType.AddToRiskWaitlist
});
export const createInvestmentAccountRequestAction = (owner, accountRelationship) => ({
  type: ActionType.CreateInvestmentAccountRequest,
  owner,
  accountRelationship
});
export const createInvestmentAccountResponseAction = response => ({
  type: ActionType.CreateInvestmentAccountResponse,
  response
});
export const createBtcWithholdingConfigRequestAction = (owner, withholdingConfig) => ({
  type: ActionType.CreateBtcWithholdingConfigRequest,
  owner,
  withholdingConfig
});
export const createBtcWithholdingConfigResponseAction = response => ({
  type: ActionType.CreateBtcWithholdingConfigResponse,
  response
});
export const getCurrentBitcoinPriceRequestAction = owner => ({
  type: ActionType.GetCurrentBitcoinPriceRequest,
  owner
});
export const getCurrentBitcoinPriceResponseAction = response => ({
  type: ActionType.GetCurrentBitcoinPriceResponse,
  response
});
export const getMaxWithholdingRequestAction = owner => ({
  type: ActionType.GetMaxWithholdingRequest,
  owner
});
export const getMaxWithholdingResponseAction = response => ({
  type: ActionType.GetMaxWithholdingResponse,
  response
});
export const listInvestmentAccountsRequestAction = owner => ({
  type: ActionType.ListInvestmentAccountsRequest,
  owner
});
export const listInvestmentAccountsResponseAction = (data, error) => ({
  type: ActionType.ListInvestmentAccountsResponse,
  data,
  error
});
export const listRecentActivityRequestAction = owner => ({
  type: ActionType.ListRecentActivityRequest,
  owner
});
export const listRecentActivityResponseAction = response => ({
  type: ActionType.ListRecentActivityResponse,
  response
});
export const navigateToBankingHomeAction = () => ({
  type: ActionType.NavigateToBankingHome
});
export const retrieveInvestEligibilityRequestAction = owner => ({
  type: ActionType.RetrieveInvestEligibilityRequest,
  owner
});
export const retrieveInvestEligibilityResponseAction = (response, error) => ({
  type: ActionType.RetrieveInvestEligibilityResponse,
  response,
  error
});
export const rotateDisplayModeAction = () => ({
  type: ActionType.RotateDisplayMode
});
export const setGrantAction = (grantId, cashtag) => ({
  type: ActionType.SetGrant,
  grantId,
  cashtag
});
export const setOnboardingScreenAction = (onboardingScreen, shouldOpenModal) => ({
  type: ActionType.SetOnboardingScreen,
  onboardingScreen,
  shouldOpenModal
});
export const setTwoFactorAuthEnabledAction = isTwoFactorEnabled => ({
  type: ActionType.SetTwoFactorAuthEnabled,
  isTwoFactorEnabled
});
export const setWaitlistedAction = isWaitlisted => ({
  type: ActionType.SetWaitlisted,
  isWaitlisted
});
export const updateBtcWithholdingConfigRequestAction = (owner, withholdingConfig, showToggleToast) => ({
  type: ActionType.UpdateBtcWithholdingConfigRequest,
  owner,
  withholdingConfig,
  showToggleToast
});
export const updateBtcWithholdingConfigResponseAction = response => ({
  type: ActionType.UpdateBtcWithholdingConfigResponse,
  response
});
export const toggleModalOpenAction = isModalOpen => ({
  type: ActionType.ToggleModalOpen,
  isModalOpen
});

// Handlers
// =============================================================================

export function handleAddToRiskWaitlistAction(context, state, _action) {
  setToLocalStorage(IS_IN_BTC_RISK_WAITLIST_LOCAL_STORAGE_KEY, true, OneTrustConsent.FUNCTIONAL);
  context.dataApi.track(INVEST_ADD_TO_INELIGIBLE_WAITLIST, {
    token: context.capitalEngineContext.sessionContext.merchantToken
  });
  return [{
    ...state,
    isInRiskWaitlist: true
  }, null];
}
export function handleCreateInvestmentAccountRequestAction(context, state, action) {
  // ensure the loading screen is displayed for at least 1 sec
  // to avoid "flash"
  const LOADING_MINIMUM_DURATION = 1000;
  const {
    owner,
    accountRelationship
  } = action;
  if (!state.grantId) {
    const error = `Problem creating an investment account: missing grantId for ${owner.id}`;
    context.marketToasts.critical(context.intl.t('banking.investments.toast.error'));
    context.sentry.captureException(error);
    return [state, null];
  }
  const request = CreateInvestmentAccountRequest.create({
    owner,
    accountRelationship,
    grantId: state.grantId
  });
  const work = () => {
    const responseAction = context.investmentsApi.createInvestmentAccount(request).then(response => {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(createInvestmentAccountResponseAction(response));
        }, LOADING_MINIMUM_DURATION);
      });
    });
    return concat(from(responseAction));
  };
  return [{
    ...state,
    isLoading: true,
    isLoadingScreen: 'linkingSuccess',
    isModalOpen: true
  }, work];
}
export function handleCreateInvestmentAccountResponseAction(context, state, action) {
  const {
    response
  } = action;
  if (response.account && response.errors.length === 0) {
    context.dataApi.track(INVEST_LINK_CASH, {
      linkStatus: 'success',
      token: context.capitalEngineContext.sessionContext.merchantToken
    });
    return [{
      ...state,
      isLoading: false,
      accounts: [response.account]
    }, () => setOnboardingScreenAction('linkingSuccess')];
  } else {
    const errorDetail = response?.errors ? response?.errors[0].detail : '';
    const error = `Problem creating an investment account: ${errorDetail}`;
    context.marketToasts.critical(context.intl.t('banking.investments.toast.error'));
    context.sentry.captureException(error);
    context.dataApi.track(INVEST_LINK_CASH, {
      linkStatus: 'error',
      token: context.capitalEngineContext.sessionContext.merchantToken
    });
    return [state, null];
  }
}
export function handleCreateBtcWithholdingConfigRequestAction(context, state, action) {
  const {
    owner,
    withholdingConfig
  } = action;
  const request = CreateBtcWithholdingConfigRequest.create({
    owner,
    withholdingConfig
  });
  const work = () => {
    const responseAction = context.investmentsApi.createBtcWithholding(request).then(createBtcWithholdingConfigResponseAction);
    return concat(from(responseAction));
  };
  return [{
    ...state,
    isLoading: true,
    isLoadingScreen: 'withholdingSuccess'
  }, work];
}
export function handleCreateBtcWithholdingConfigResponseAction(context, state, action) {
  const {
    response
  } = action;
  if (response.withholdingConfig && response.errors.length === 0) {
    return [{
      ...state,
      isLoading: false,
      currentOnboardingScreen: 'success',
      withholdingConfig: response.withholdingConfig,
      withholdingBps: response.withholdingConfig.withholdingBps
    }, null];
  } else {
    const error = `Problem creating BTC withholding: ${response.errors[0].detail}`;
    context.marketToasts.critical(context.intl.t('banking.investments.toast.error'));
    context.sentry.captureException(error);
    return [{
      ...state,
      isLoading: false
    }, null];
  }
}
export function handleGetCurrentBitcoinPriceRequestAction(context, state, action) {
  const {
    owner
  } = action;
  const request = GetCurrentBitcoinPriceRequest.create({
    owner
  });
  const work = () => {
    const responseAction = context.investmentsApi.getCurrentBitcoinPrice(request).then(getCurrentBitcoinPriceResponseAction).catch(() => getCurrentBitcoinPriceResponseAction());
    return concat(from(responseAction));
  };
  return [{
    ...state,
    getCurrentBitcoinPriceState: FetchState.LOADING
  }, work];
}
export function handleGetCurrentBitcoinPriceResponseAction(context, state, action) {
  const {
    response
  } = action;
  const isLoading = false;
  if (!response || !response.currentBtcPrice) {
    context.sentry.captureException('Failed to fetch the current bitcoin price');
    return [{
      ...state,
      isLoading,
      getCurrentBitcoinPriceState: FetchState.ERROR
    }, null];
  }
  return [{
    ...state,
    currentBitcoinPrice: response.currentBtcPrice,
    getCurrentBitcoinPriceState: FetchState.COMPLETED,
    isLoading
  }, null];
}
export function handleGetMaxWithholdingRequestAction(context, state, action) {
  const {
    owner
  } = action;
  const request = GetMaxWithholdingRequest.create({
    owner
  });
  const work = () => {
    const responseAction = context.investmentsApi.getMaxWithholding(request).then(getMaxWithholdingResponseAction);
    return concat(from(responseAction));
  };
  return [state, work];
}
export function handleGetMaxWithholdingResponseAction(context, state, action) {
  const {
    response
  } = action;
  if (response.withholdingBps !== undefined) {
    return [{
      ...state,
      maxWithholdingBps: response.withholdingBps
    }, null];
  } else {
    context.marketToasts.critical(context.intl.t('banking.investments.toast.error'));
    context.sentry.captureException('Problem fetching max withholding bps');
    // Can't fetch max withholding bps, go back to banking home page
    return [state, navigateToBankingHomeAction];
  }
}
export function handleListInvestmentAccountsRequestAction(context, state, action) {
  const {
    owner
  } = action;
  const request = ListInvestmentAccountsRequest.create({
    owner
  });
  const work = () => {
    const responseAction = context.investmentsApi.listInvestmentAccounts(request).then(listInvestmentAccountsResponseAction).catch(error => listInvestmentAccountsResponseAction(undefined, error));
    return concat(from(responseAction));
  };
  return [{
    ...state,
    listInvestmentAccountState: FetchState.LOADING
  }, work];
}
export function handleListInvestmentAccountsResponseAction(context, state, action) {
  const {
    data,
    error
  } = action;
  let listInvestmentAccountState = FetchState.COMPLETED;
  const accounts = data?.accounts;

  // Assumes there is no more than one BTC account per merchant,
  // which may not stay true after alpha.
  const btcAccount = accounts?.find(investmentAccount => investmentAccount.accountType === AccountType.BTC_TREASURY && (investmentAccount.accountStatus === InvestmentAccountMetadata.AccountStatus.ACTIVE || investmentAccount.accountStatus === InvestmentAccountMetadata.AccountStatus.PENDING_WITHHOLDING));
  if (accounts?.some(investmentAccount => investmentAccount.accountStatus === InvestmentAccountMetadata.AccountStatus.DEACTIVATED)) {
    context.sentry.captureMessage('Seller has deactivated Invest account');
    // Deactivated account, go back to banking home page
    return [{
      ...state,
      accounts,
      btcAccount,
      listInvestmentAccountState
    }, navigateToBankingHomeAction];
  }
  if (!accounts || !btcAccount) {
    if (error) {
      context.sentry.captureException(error);
      listInvestmentAccountState = FetchState.ERROR;
    }
    if (isInvestmentsRoute(context.router.currentRouteName)) {
      context.sentry.captureMessage('No investment account exists');
      // No accounts, go back to banking home page
      return [{
        ...state,
        listInvestmentAccountState
      }, navigateToBankingHomeAction];
    } else {
      // On banking home page if no accounts, do nothing
      return [{
        ...state,
        listInvestmentAccountState
      }, null];
    }
  } else if (!btcAccount.withholdingConfig) {
    // Has account but no withholding config
    return [{
      ...state,
      accounts,
      btcAccount,
      listInvestmentAccountState
    }, () => setOnboardingScreenAction('withholding')];
  } else {
    const withholdingConfig = btcAccount.withholdingConfig;

    // NOTE: skip BTC mode if sats value < MIN_BITCOIN_DISPLAY_AMOUNT
    let nextDisplayMode = state.displayMode;
    if (state.canSeeBitcoinFiatConversion && btcAccount?.currentBalance && btcAccount.currentBalance.amount < MIN_BITCOIN_DISPLAY_AMOUNT && state.displayMode === DisplayMode.BTC_MODE) {
      nextDisplayMode = DisplayMode.SATOSHI_MODE;
    }
    return [{
      ...state,
      accounts,
      btcAccount,
      withholdingConfig,
      withholdingBps: withholdingConfig.withholdingBps,
      displayMode: nextDisplayMode,
      listInvestmentAccountState
    }, () => setOnboardingScreenAction('withholding')];
  }
}
export function handleListRecentActivityRequestAction(context, state, action) {
  const {
    owner
  } = action;
  const request = ListRecentActivityRequest.create({
    owner
  });
  const work = () => {
    const responseAction = context.investmentsApi.listRecentActivity(request).then(listRecentActivityResponseAction);
    return concat(from(responseAction));
  };
  return [state, work];
}
export function handleListRecentActivityResponseAction(context, state, action) {
  const {
    response
  } = action;
  if (response.activities) {
    return [{
      ...state,
      activities: response.activities
    }, null];
  } else {
    context.sentry.captureException('Error listing recent activities');
    return [{
      ...state
    }, null];
  }
}
export function handleNavigateToBankingHomeAction(_context, state, _action) {
  // We do nothing here, because the logic for router transitions is
  // inside of `./router-transitions.ts`.
  return [{
    ...state
  }, null];
}
export function handleRetrieveInvestEligibilityRequestAction(context, state, action) {
  const {
    owner
  } = action;
  const request = RetrieveInvestEligibilityRequest.create({
    owner
  });
  const work = () => {
    const responseAction = context.investmentsApi.retrieveInvestEligibility(request).then(retrieveInvestEligibilityResponseAction).catch(error => retrieveInvestEligibilityResponseAction(undefined, error));
    return concat(from(responseAction));
  };
  return [{
    ...state,
    riskEligibility: RiskEligibility.LOADING
  }, work];
}
export function handleRetrieveInvestEligibilityResponseAction(context, state, action) {
  const {
    response,
    error
  } = action;
  if (!response || error) {
    context.sentry.captureException(error);
    return [{
      ...state,
      riskEligibility: RiskEligibility.ERROR
    }, null];
  }
  const riskEligibility = response.eligible ? RiskEligibility.ELIGIBLE : RiskEligibility.INELIGIBLE;
  context.dataApi.track(INVEST_ELIGIBILITY, {
    token: context.capitalEngineContext.sessionContext.merchantToken,
    eligible: response.eligible
  });

  // We always call RetrieveInvestEligibility, whether a seller is waitlisted or not.
  // This approach addresses a rare scenario where RetrieveInvestEligibility previously returned false for a seller,
  // but over time, the seller becomes eligible. In such cases, we should clear the local storage cache
  // and display the bitcoin upsell component.
  if (riskEligibility === RiskEligibility.ELIGIBLE && state.isInRiskWaitlist) {
    removeFromLocalStorage(IS_IN_BTC_RISK_WAITLIST_LOCAL_STORAGE_KEY);
    return [{
      ...state,
      riskEligibility,
      isInRiskWaitlist: false
    }, null];
  }
  return [{
    ...state,
    riskEligibility
  }, null];
}
export function handleRotateDisplayMode(_context, state, _action) {
  const currentDisplayMode = state.displayMode;
  let nextDisplayMode = (currentDisplayMode + 1) % (Object.keys(DisplayMode).length / 2);

  // NOTE: skip BTC mode if sats value < MIN_BITCOIN_DISPLAY_AMOUNT
  if (balance(state).amount < MIN_BITCOIN_DISPLAY_AMOUNT && nextDisplayMode === DisplayMode.BTC_MODE) {
    nextDisplayMode = DisplayMode.SATOSHI_MODE;
  }
  return [{
    ...state,
    displayMode: nextDisplayMode
  }, null];
}
export function handleSetGrantAction(context, state, action) {
  const {
    grantId,
    cashtag
  } = action;
  context.dataApi.track(INVEST_SET_CASH_LINKING_GRANT, {
    token: context.capitalEngineContext.sessionContext.merchantToken
  });
  return [{
    ...state,
    cashtag,
    grantId
  }, () => setOnboardingScreenAction('accountRelationship', true)];
}
export function handleSetOnboardingScreenAction(_context, state, action) {
  const {
    onboardingScreen,
    shouldOpenModal
  } = action;
  return [{
    ...state,
    currentOnboardingScreen: onboardingScreen,
    isLoading: onboardingScreen === 'confirm' ? state.getCurrentBitcoinPriceState === FetchState.LOADING : state.isLoading,
    // shouldOpenModal: if set to true explicitly, should open the modal
    isModalOpen: shouldOpenModal ? true : state.isModalOpen
  }, null];
}
export function handleToggleModalOpenAction(_context, state, action) {
  const {
    isModalOpen
  } = action;
  return [{
    ...state,
    // reset onboarding screen to splash when closing the modal
    currentOnboardingScreen: isModalOpen ? state.currentOnboardingScreen : 'splash',
    isModalOpen
  }, null];
}
export function handleSetTwoFactorAuthEnabledAction(context, state, action) {
  const {
    isTwoFactorEnabled
  } = action;
  context.dataApi.track(INVEST_CHECK_TWO_FACTOR, {
    token: context.capitalEngineContext.sessionContext.merchantToken,
    twoFactorStatus: isTwoFactorEnabled
  });
  return [{
    ...state,
    isTwoFactorEnabled
  }, null];
}
export function handleSetWaitlistedAction(context, state, action) {
  const {
    isWaitlisted
  } = action;
  setToLocalStorage(IS_IN_BTC_BUSINESS_TYPE_WAITLIST_LOCAL_STORAGE_KEY, true, OneTrustConsent.FUNCTIONAL);
  context.dataApi.track(INVEST_SET_WAITLISTED, {
    token: context.capitalEngineContext.sessionContext.merchantToken,
    isWaitlisted
  });
  return [{
    ...state,
    isInBusinessTypeWaitlist: isWaitlisted
  }, null];
}
export function handleUpdateBtcWithholdingConfigRequestAction(context, state, action) {
  const {
    owner,
    withholdingConfig,
    showToggleToast
  } = action;
  const request = UpdateBtcWithholdingConfigRequest.create({
    owner,
    withholdingConfig
  });
  const work = () => {
    const responseAction = context.investmentsApi.updateBtcWithholding(request).then(updateBtcWithholdingConfigResponseAction);
    return concat(from(responseAction));
  };
  return [{
    ...state,
    isLoading: true,
    isLoadingScreen: 'withholdingSuccess',
    showToggleToast
  }, work];
}
export function handleUpdateBtcWithholdingConfigResponseAction(context, state, action) {
  const {
    response
  } = action;
  if (response.withholdingConfig && response.errors.length === 0) {
    if (state.showToggleToast) {
      let intlKey;
      if (response.withholdingConfig.enabled) {
        intlKey = 'banking.investments.toast.enabled';
      } else {
        intlKey = 'banking.investments.toast.disabled';
      }
      context.marketToasts.success(context.intl.t(intlKey));
    } else {
      context.dataApi.track(INVEST_COMPLETE_ONBOARDING, {
        token: context.capitalEngineContext.sessionContext.merchantToken
      });
    }
    context.dataApi.track(INVEST_CREATE_UPDATE_WITHHOLDING, {
      withholdingBps: response.withholdingConfig.withholdingBps / 100,
      token: context.capitalEngineContext.sessionContext.merchantToken
    });
    return [{
      ...state,
      isLoading: false,
      currentOnboardingScreen: 'success',
      showToggleToast: false,
      withholdingConfig: response.withholdingConfig,
      withholdingBps: response.withholdingConfig.withholdingBps
    }, null];
  } else {
    const error = `Problem updating BTC withholding: ${response.errors[0].detail}`;
    context.marketToasts.critical(context.intl.t('banking.investments.toast.error'));
    context.sentry.captureException(error);
    return [{
      ...state,
      isLoading: false
    }, null];
  }
}